import React from 'react';
import { toastr } from 'react-redux-toastr';
import api from '../../../api';
import '../../../styles/details.scss';
import { WappNotificationTemplate, ICreateWappTemplate } from '../../../core';
import WappTemplate from './WappTemplate';

const AddWappForm: React.FunctionComponent<{
  onClose?: () => void;
  isEdit: boolean;
  template?: WappNotificationTemplate;
  key: string;
  subject: string;
  realod: () => void;
}> = (props) => {
  const onSubmit = async (data?: any) => {
    const updateData: ICreateWappTemplate = {
      key: props.key,
      messageTemplate: data.messageTemplate?.toString('html'),
      isActive: props.template?.isActive || false,
      isDocumentTemplate: data.isDocumentTemplate || false,
      approvedReferenceTemplate: data.approvedReferenceTemplate?.toString(
        'html'
      ),
      useBrochureTemplate: data.useBrochureTemplate || false,
    };

    try {
      await api.settings.updateTemplateContent(
        'wapp',
        props.template?._id || '',
        updateData
      );
      props.onClose?.();
      props.realod?.();
      toastr.success('Success', 'Wapp template saved successfully');
    } catch (error) {
      if (error?.response?.data?.data?.message) {
        toastr.error('Error', error?.response?.data?.data?.message.join());
      } else {
        toastr.error('Error', error?.response?.data?.message);
      }
    }
  };

  return (
    <>
      <div className="detail-poupup bg-white position-fixed top-0 w-100 h-100 overflow-auto in">
        <div className="container-fluid bg-gray-100 border-bottom py-3 position-sticky top-0 zIndex-9">
          <div className="row align-items-center">
            <div className="col-auto" onClick={props.onClose}>
              <i className="icon-close text-gray-500 font-xxl cursor-pointer"></i>
            </div>
            <div className="col">
              <h5 className="mb-0">Update {props.subject}</h5>
            </div>

            <div className="col-auto mt-md-0 mt-1"></div>
          </div>
        </div>

        <div className="container-fluid px-0 ch-100">
          <div className="row no-gutters h-100 bg-gray-100">
            <WappTemplate
              isEdit={props.isEdit}
              templateDetails={props.template}
              onSubmit={onSubmit}
              onClose={props.onClose}
            ></WappTemplate>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
};

export default AddWappForm;
